<template>
  <div>
    <div v-if="po.offerViewMode !== 'hub'" class="quick-actions" style="margin-bottom: 12px">
      <button type="button" class="button is-small is-light" @click="po.goToOfferHub">
        <i class="fa fa-arrow-left"></i> Kthehu te fushatat
      </button>
      <span v-if="po.offerDraftGuid" class="chip muted">{{ po.offerForm.label || "Oferta" }} — {{ po.offerStatusLabel(po.offerLoadedCampaignStatus) }}</span>
    </div>

    <FushatHub v-if="po.offerViewMode === 'hub'" />
    <OfertaWizard v-else-if="po.offerViewMode === 'wizard'" />
    <OfertaLiveView v-else-if="po.offerViewMode === 'live'" />

    <div v-if="po.offerFushatModalOpen" class="modal is-active offer-campaign-modal">
      <div class="modal-background" @click="po.closeOfferFushatModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ po.offerFushatModalTitle }}</p>
          <button type="button" class="delete" aria-label="close" @click="po.closeOfferFushatModal"></button>
        </header>
        <section class="modal-card-body">
          <div class="field-grid">
            <label>Emri i fushatës</label>
            <input v-model="po.offerFushatForm.name" class="input-clean" type="text" placeholder="P.sh. Super Oferta Vere 2026" />
            <label>Kodi i fushatës</label>
            <input v-model="po.offerFushatForm.code" class="input-clean" type="text" placeholder="P.sh. SUMMER26" />
            <label>Imazh i fushatës (URL ose path)</label>
            <input v-model="po.offerFushatForm.image" class="input-clean" type="text" placeholder="P.sh. /uploads/campaigns/summer26.jpg" />
            <div class="quick-actions">
              <input class="input-clean" type="file" accept="image/*" @change="po.onOfferFushatImagePicked" />
              <button type="button" class="button is-small" @click="po.uploadOfferFushatImage" :disabled="!po.offerFushatImageFile || po.offerFushatImageUploading">
                {{ po.offerFushatImageUploading ? "Duke ngarkuar..." : "Ngarko imazh" }}
              </button>
            </div>
            <div v-if="po.offerFushatImagePreviewUrl" class="offer-image-preview-wrap">
              <img :src="po.offerFushatImagePreviewUrl" class="offer-image-preview" alt="Fushat image" />
            </div>
          </div>
        </section>
        <footer class="modal-card-foot offer-campaign-modal-foot">
          <span class="offer-campaign-modal-foot-spacer"></span>
          <button type="button" class="button" @click="po.closeOfferFushatModal">Mbyll</button>
          <button type="button" class="button is-primary" @click="po.saveOfferFushatFromModal" :disabled="po.offerFushatSaving">
            {{ po.offerFushatSaving ? "Duke ruajtur..." : "Ruaj fushatën" }}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import FushatHub from "./FushatHub.vue";
import OfertaWizard from "./OfertaWizard.vue";
import OfertaLiveView from "./OfertaLiveView.vue";

export default {
  name: "OfertaTab",
  components: { FushatHub, OfertaWizard, OfertaLiveView },
  inject: ["po"],
};
</script>
